import { Pipe, PipeTransform } from '@angular/core';

import { mercadoSituacoes } from '../mercado-situacao';

@Pipe({
    name: 'mercadoSituacao'
})
export class MercadoSituacaoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = mercadoSituacoes.findIndex(situacao => situacao.id === value);
        if (index > -1) {
            return mercadoSituacoes[index].nome;
        }
        return '';
    }
}
